import { MessageCircle } from "lucide-react";
import { waLink } from "../../constants/data";

export default function WhatsAppFloat() {
  return (
    <a
      href={waLink("Hi! I'd like to inquire about your gift hampers.")}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      className="fixed bottom-6 right-6 z-40 bg-[#25D366] text-white w-14 h-14 rounded-full shadow-lg flex items-center justify-center hover:bg-[#1da851] transition-all hover:scale-105"
      aria-label="WhatsApp"
    >
      <MessageCircle className="w-6 h-6" strokeWidth={1.5} />
    </a>
  );
}
